<template>
  <div>
    <lm-image1 :shadow="false" :scale="false" :src="swiper">
      <div slot="title" style="width: 1500px; margin: 0 auto; font-size: 48px;text-align: center">Learn. Grow. Thrive.</div>
    </lm-image1>
    <!-- Research Project -->
    <lm-swatches-block :space="43.75">
      <lm-container :width="1500">
        <h2>Research Project</h2>
        <lm-figuare :src="img4" :list="module4"></lm-figuare>
      </lm-container>
    </lm-swatches-block>

    <lm-swatches-block backgroundColor="#f4f4f4" :space="43.75">
      <lm-container :width="1500">
        <h2>School Calendar</h2>
        <lm-figuare :src="img1" :list="module1"></lm-figuare>
      </lm-container>
    </lm-swatches-block>

    <lm-swatches-block :space="43.75">
      <lm-container :width="1500">
        <h2>Graduate Studies</h2>
        <lm-figuare :src="img2" :list="module2"></lm-figuare>
      </lm-container>0
    </lm-swatches-block>

    <lm-swatches-block backgroundColor="#f4f4f4" :space="43.75">
      <lm-container :width="1500">
        <h2>Learning Materials</h2>
        <lm-figuare :src="img3" :list="module3"></lm-figuare>
      </lm-container>
    </lm-swatches-block>
  </div>
</template>

<script>
import { frontArticles4Memu, frontThrMenu } from '@/api/api';
import { methodsMixins } from '@/mixins/index';
import PosterModule from '../column/components/PosterModule';

export default {
  components: {
    PosterModule
  },
  mixins: [methodsMixins],
  data() {
    return {
      swiper: require('@/assets/academics/swiper.jpg'),
      img1: require('@/assets/academics/1.jpg'),
      img2: require('@/assets/academics/2.jpg'),
      img3: require('@/assets/academics/3.jpg'),
      img4: require('@/assets/academics/4.jpg'),
      module1: [],
      module2: [],
      module3: [],
      module4: []
    }
  },
  created() {
    const list1 = [],
    list2 = [],
    list3 = [],
    list4 = [],
    list5 = [],
    list6 = [],
    list7 = [],
    list8 = [],
    list9 = [];
    //this.getArticles('y0lm76m9z3', 'y0lw3ju0zs', list1);
    this.getArticles('y0lm76m9z3', 'y0lw3jv8p1', list2);
    this.getArticles('y0lm76m9z3', 'y0lw3jw0p0', list3);
    this.getArticles('y0lm76m9z3', 'y0lw3jwfdq', list4);
    this.getArticles('y0lm76m9z3', 'y0lwm06r2s', list5);
    this.getArticles('y0lm76m9z3', 'y0lwm06x40', list6);
    this.getArticles('y0lm76m9z3', 'y0lwm09acc', list7);
    this.getArticles('y0lm76m9z3', 'y0lwm0b27j', list8);
    this.getArticles('y0lm76m9z3', 'y0mgon18y2', list9);
    this.module4 = [{
      title: 'Research Project',
      articles: list9
    }];
    this.module1 = [/*{
      title: 'Semester two，Acadenic Year 2023-2024',
      articles: list1
    }, */{
      title: 'School Calendars',
      articles: list2
    }];
    this.module2 = [{
      title: 'Postgraduate',
      articles: list3
    }, {
      title: 'Undergraduate',
      articles: list4
    }, {
      title: 'Explore More',
      articles: list5
    }];
    this.module3 = [{
      title: 'HSK',
      articles: list6
    }, {
      title: 'Instructions',
      articles: list7
    }, {
      title: 'Affiliated Hospitals',
      articles: list8
    }];
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';
@import '../home/index.scss';
</style>
